var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "title-slot" }, [
    _c("div", { staticClass: "title-slot__left float-left" }, [
      _vm.showDot
        ? _c(
            "div",
            { staticClass: "title-slot__dot" },
            [
              _c(
                "DottedDropdown",
                { attrs: { id: "workpermit-collapse-title_" + _vm.id } },
                _vm._l(_vm.dotOption, function (item, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        staticClass: "dot-option-btn",
                        on: {
                          click: function () {
                            return item.operate && item.operate(_vm.permitData)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(item.title) + "\n          "
                        ),
                      ]
                    ),
                  ])
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "title-slot__box" }, [
        _c("div", { staticClass: "title-slot__code" }, [
          _vm._v(
            "\n        # " + _vm._s(_vm.innerData.code || "--") + "\n      "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "title-slot__title" },
          [
            !_vm.title
              ? [
                  _c("strong", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.displayTitle) +
                        " -\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n            (" +
                        _vm._s(
                          _vm._f("formatDate")(
                            _vm.innerData.startDate,
                            "DD MMM YY HH:mm"
                          )
                        ) +
                        " - " +
                        _vm._s(
                          _vm._f("formatDate")(
                            _vm.innerData.endDate,
                            "DD MMM YY HH:mm"
                          )
                        ) +
                        ")\n          "
                    ),
                  ]),
                ]
              : _c("strong", [_vm._v(_vm._s(_vm.title))]),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.showStatus
      ? _c(
          "div",
          {
            staticClass: "pointer title-slot__right",
            on: {
              click: function ($event) {
                return _vm.openLifecycleModal()
              },
            },
          },
          [
            _c("div", { class: _vm.statusStyle }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("customStatusLabel")(_vm.formatStatus)) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("Lifecycle", {
              ref: "workPermitLifecycle",
              attrs: {
                modalId: "work-permit-modules-" + _vm.id + "-lifecycle-modal",
                commentAttr: _vm.lifecycleCommentAttrs.comments,
                htmlCommentAttr: _vm.WP_LIFECYCLE_COMMENT_HTML_KEY,
                histories: _vm.histories || [],
                type: "workPermit",
                allowPreformattedComments: true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }